import React, { useState } from "react";
import "./AboutExtended.css";
import Navbar from "../Navbar/Navbar";
import ScrollToTop from "../services/scrollToTop";
import Footer from "../Footer/Footer";

const AboutExtended = (props) => {
  const [activeTab, setActiveTab] = useState("conductor");

  const tabs = [
    { key: "conductor", label: props.content.conductor.title },
    { key: "choir",     label: "CCC" },
    { key: "c5",        label: "C5" },
    { key: "cco",       label: "CCO" },
    { key: "museed",    label: "Museed" },
  ];

  return (
    <div className="AboutExtended">
      <ScrollToTop />
      <Navbar />

      {/* Banner */}
      <div className="row col-lg-12 mx-0">
        <div className="about-banner col-lg-12">
          <h1 className="about-banner-title mx-auto">About</h1>
        </div>
      </div>

      {/* Tab bar */}
      <div className="about1-tab-bar">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`about1-tab${activeTab === tab.key ? " about1-tab--active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ── The Choir ── */}
      {activeTab === "choir" && (
        <div className="about1-panel">
          <div className="about1-stack">
            <img
              className="about1-stack__hero"
              src={require("../../assets/Images/choir1.png")}
              alt="Choir"
            />
            <div className="about1-stack__body">
              <p>{props.content.choir.description}</p>
              {props.content.choir.otherContent?.map((content, idx) => (
                <div key={idx}>
                  <h4 className="about1-stack__heading">{content.title}</h4>
                  <p>{content.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── The Conductor ── */}
      {activeTab === "conductor" && (
        <div className="about1-panel">
          <div className="about1-stack">
            <img
              className="about1-stack__hero"
              src={require("../../assets/Images/conductor.png")}
              alt="Conductor"
            />
            <div className="about1-stack__body">
              {props.content.conductor.description.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
              {props.content.conductor.otherContent?.map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── C5 ── */}
      {activeTab === "c5" && (
        <div className="about1-panel">
          <div className="about1-c5">
            <img
              className="about1-c5__hero"
              src={require("../../assets/Images/c5_1.jpg")}
              alt="CCC Children's Choir"
            />
            <div className="about1-c5__body">
              <p>
                Recognizing the burgeoning enthusiasm and remarkable aptitude
                displayed by young singers during Coimbatore Chamber Chorale (CCC)
                rehearsals and concerts, we identified a unique opportunity.
                Witnessing their ability to master complex musical pieces, we were
                inspired to cultivate a dedicated space for age-appropriate, engaging,
                and enriching musical exploration.
              </p>
              <p>
                Thus, the Coimbatore Chamber Chorale Children's Choir (C5) was
                established, providing a nurturing environment where young voices
                could delve into the captivating world of choral music. Our mission is
                to foster a lifelong love for singing, creating a space where children
                eagerly gather each week to express themselves through melody.
              </p>

              <h4 className="about1-c5__heading">Highlights</h4>
              <ul className="about1-c5__list">
                <li>
                  <strong>Target Age Group:</strong> Children aged 7 to 12.
                </li>
                <li>
                  <strong>Curriculum:</strong> Focus on fundamental musical concepts,
                  including pitch, rhythm, and harmony, designed to enhance musical
                  proficiency and build vocal confidence.
                </li>
                <li>
                  <strong>Dynamic Sessions:</strong> Energetic rehearsals featuring
                  interactive warm-up exercises, vocal preparation, and exploration of
                  diverse musical themes.
                </li>
                <li>
                  <strong>Repertoire:</strong> Performance of esteemed compositions
                  such as John Rutter's "For the Beauty of the Earth," David
                  Archuleta's "Glorious," the Zambian folk song "Bonse Aba," Shawna
                  Edwards' "Risen," and a selection of cherished hymns.
                </li>
                <li>
                  <strong>Summer Workshops:</strong> Intensive workshops dedicated to
                  comprehensive musical education, encompassing vocal techniques and
                  music theory.
                </li>
              </ul>

              <h4 className="about1-c5__heading">Impact</h4>
              <p>
                In just one year, C5 has successfully nurtured young talents, guiding
                them to deliver polished performances of challenging and diverse
                repertoire. Our commitment extends beyond performance, aiming to
                provide a holistic musical education that empowers children to explore
                and appreciate the art of choral singing.
              </p>
              <p>
                We invite young singers to join the C5 community and embark on a
                rewarding musical journey. Discover the joy of choral music and
                develop your musical potential with us.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ── CCO ── */}
      {activeTab === "cco" && (
        <div className="about1-panel">
          <div className="about1-cco">
            <div className="about1-cco__body">
              <p>
                The Coimbatore Chamber Orchestra (CCO), founded by Mr. Faith Ragland in 2023,
                was established with the vision of bringing musicians together in a spirit of
                orchestral unity and collaboration. The orchestra actively engages with various
                ensembles and choirs, fostering a vibrant and cohesive musical community.
              </p>
              <p>
                With a strong commitment to enriching the cultural landscape, the CCO actively
                partners with ensembles and choirs, creating powerful and memorable musical
                experiences. The orchestra has performed across Tirunelveli, Coimbatore, Trichy,
                and Bangalore, captivating audiences with a repertoire that bridges timeless
                masterpieces and contemporary brilliance—from the elegance of Bach, Haydn, and
                Mozart to the vibrant works of John Rutter and Karl Jenkins.
              </p>
              <p>
                Beyond performances, the CCO regularly conducts workshops and recitals aimed at
                nurturing young musicians and deepening their understanding of orchestral music
                and ensemble performance. The orchestra’s primary objective is to provide a
                platform where musicians can continually learn, refine their artistry, and grow
                together through music.
              </p>

              <h4 className="about1-cco__heading">Highlights</h4>

              <h5 className="about1-cco__subheading">Concerts</h5>
              <p>
                The CCO has collaborated with several choirs across Tamil Nadu, performing major
                works such as The Creation by Franz Joseph Haydn, and Messiah and Israel in Egypt
                by George Frideric Handel. The orchestra has also recently partnered with the
                English Brass Collective from the United Kingdom, further enriching its musical
                engagements.
              </p>

              <h5 className="about1-cco__subheading">Practice Sessions</h5>
              <p>
                Regular rehearsals are held every Sunday, focusing on Western classical repertoire
                and traditional church hymns. These sessions are designed to refine individual
                technique while strengthening ensemble cohesion.
              </p>

              <h5 className="about1-cco__subheading">Workshops</h5>
              <p>
                Guided by the leadership of Mr. Faith Ragland, the orchestra both organizes and
                participates in workshops aimed at helping instrumentalists reach their full
                artistic potential. Recently, the CCO attended a workshop in Coonoor led by Mr.
                and Mrs. Bower and Ms. SeungHyea Jung, which was an enriching experience for all
                the participants.
              </p>

              <p>
                The Coimbatore Chamber Orchestra warmly welcomes new members who share a passion
                for music, collaboration, and performance. Musicians of all ages are invited to
                join this journey of dynamic, expressive, and enriching orchestral music-making,
                united by a shared love for music.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* ── Museed ── */}
      {activeTab === "museed" && (
        <div className="about1-panel">
          <div className="about1-museed">
            <div className="about1-museed__pics">
              <img src={require("../../assets/Images/museed_1.jpeg")} alt="Museed session 1" />
              <img src={require("../../assets/Images/museed_2.jpeg")} alt="Museed session 2" />
              <img src={require("../../assets/Images/museed_3.jpeg")} alt="Museed session 3" />
            </div>
            <div className="about1-museed__body">
              <p>Having progressed over the years in performing various genres of music across various stages,
                members of CCC had a unifying urge to share the joy of art music with everyone in the community.
                To take quality music education to the fringes of our community and to make art music accessible to
                all, CCC initiated MuSeed in the year 2021.</p>
              <p>Marginalised communities are in various pockets of our city and choir members located one such
                group in the Kakkan Nagar surrounding. Children there are of all age groups. They are just as
                dynamic and vibrant as any child and the one thing that separates them from the rest of their peer is
                the lack of opportunity. To begin with, members of CCC visited the community and began teaching
                the children some basics through singing and a little music theory. Very quickly the children were
                introduced to the fundamentals of playing the violin. But why the violin? Playing a stringed
                instrument is a skill that isn't easily acquired. It builds confidence and when played in a group as in
                an orchestra, it imparts a positive team spirit.</p>
              <p>MuSeed is largely volunteer driven. A team of proactive youngsters, many of whom are violinists
                themselves have come forward to teach. MuSeed began with around 30 children, out of which, 10
                have shown good progress. What stands out among these children is the musical aptitude that
                remained latent within them. It had to be tapped. Word spread across ardent music lovers who have
                contributed violins and other music accessories for the cause.</p>
              <p>Futuristic goals include taking these children to advanced levels of violin training and to provide
                learning opportunities that are designed to nurture these children on their unique musical
                experiences. The journey ahead may not be an easy one but who knows, there could be a virtuoso
                lurking among them and MuSeed could be a gateway to a career in music or an opportunity for a
                deserving child to reach his or her full potential.</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default AboutExtended;
